module.exports = __webpack_public_path__ + "static/media/html.5d2b1a80.png";